/*
 * COPYRIGHT © 2026 SANITÀNEXUS WHITE-LABEL. ALL RIGHTS RESERVED.
 * AUTHOR AND SOLE DEVELOPER: MARCO PANZETTI (C.F. PNZMRC89M14F251C)
 * Protected under Italian Copyright Law (Legge 633/1941) and International Treaties.
 * Unauthorized copying, reverse engineering, or distribution of this software architecture,
 * UI/UX layouts, local-first logic, or system prompt configurations is strictly prohibited.
 */
import api from '@/lib/api';

// Prescriptions
export const createPrescription = (payload) => api.post('/medical/prescriptions', payload).then(r => r.data);
export const listMyPrescriptions = () => api.get('/medical/prescriptions/mine').then(r => r.data);
export const getPrescription = (id) => api.get(`/medical/prescriptions/${id}`).then(r => r.data);

// Wallet documents
export const uploadDocument = (payload) => api.post('/medical/documents', payload).then(r => r.data);
export const listMyDocuments = () => api.get('/medical/documents/mine').then(r => r.data);
export const deleteDocument = (id) => api.delete(`/medical/documents/${id}`).then(r => r.data);
